import { Component, OnInit, Input } from '@angular/core';
import { Stroke } from '../../types';

@Component({
  selector: 'g[svg-path]',
  templateUrl: './svgpath.component.html',
  styleUrls: ['./svgpath.component.css']
})
export class SvgPathComponent implements OnInit {

  constructor() { }


  @Input()
  public path: string;

  @Input()
  public stroke: Stroke;

  ngOnInit() {
    if (!this.stroke) {
      this.stroke = new Stroke();
    }
  }

}
